import React, { useState } from 'react';
import './App.css';
import GameBoard from './components/GameBoard/GameBoard';
import Particles from './components/Particles/Particles';

function App() {
  const [gameMode, setGameMode] = useState<'min-heap' | 'max-heap'>('min-heap');
  const [resetKey, setResetKey] = useState(0); // Key to force GameBoard remount on clear

  // Function to clear the heap by forcing a remount of GameBoard
  const handleClear = () => {
    setResetKey(prev => prev + 1);
  };
  
  // Function to switch game mode
  const handleGameModeChange = (mode: 'min-heap' | 'max-heap') => {
    setGameMode(mode);
  };

  return (
    <div className="App">
      <Particles />
      
      {/* Title in center */}
      <h1 className="gameTitle">Heapnosis</h1>
      
      {/* Controls - positioned differently on mobile vs desktop */}
      
      {/* Desktop controls (left and right of title) */}
      <div className="desktopControls">
        {/* Mode selector in upper left */}
        <div className="upperLeftControls">
          <div className="gameModeSelector">
            <button 
              className={`modeButton ${gameMode === 'min-heap' ? 'active' : ''}`}
              onClick={() => handleGameModeChange('min-heap')}
            >
              MIN
            </button>
            <button 
              className={`modeButton ${gameMode === 'max-heap' ? 'active' : ''}`}
              onClick={() => handleGameModeChange('max-heap')}
            >
              MAX
            </button>
          </div>
        </div>
        
        {/* Clear button in upper right */}
        <div className="upperRightControls">
          <button 
            className="clearButton"
            onClick={handleClear}
          >
            CLEAR
          </button>
        </div>
      </div>
      
      {/* Mobile controls (below title) */}
      <div className="mobileControls">
        <div className="controlsWrapper">
          <div className="gameModeSelector">
            <button 
              className={`modeButton ${gameMode === 'min-heap' ? 'active' : ''}`}
              onClick={() => handleGameModeChange('min-heap')}
            >
              MIN
            </button>
            <button 
              className={`modeButton ${gameMode === 'max-heap' ? 'active' : ''}`}
              onClick={() => handleGameModeChange('max-heap')}
            >
              MAX
            </button>
          </div>
          
          <button 
            className="clearButton"
            onClick={handleClear}
          >
            CLEAR
          </button>
        </div>
      </div>
      
      {/* Main game board - using key to force remount on clear */}
      <GameBoard 
        key={resetKey} 
        gameMode={gameMode}
      />
    </div>
  );
}

export default App;